<script setup lang="ts">
import { LandingModule } from "@/modules/landing-module";
import { OfferModule } from "@/modules/offer-module";
import { useRoute } from "vue-router";
import { PlaceModule } from "@/modules/place-module";

const route = useRoute();
</script>

<template>
  <OfferModule v-if="route.query.offer" />
  <PlaceModule v-if="route.query.place" />
  <LandingModule />
</template>
